import React, { useEffect, useState } from 'react';

import RotuloSeplag from '../../../../../components/RotuloSeplag';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Card } from "primereact/card";
import style from "./style.module.scss";

function CustomizedContent({ optionsOrgaoDeOrigemDaObrigacao, item }) {

  return (
    <Card>
      <div className={style.cabecalho}>
        <div className={`p-card-title ${item.auditoriaDTO.ultimaVersao && style.cardTitle}`}>
          {item.auditoriaDTO.revtypeFormatada}
          {item.auditoriaDTO.ultimaVersao && (
            <i className="pi pi-check " style={{ color: "#077F41", fontSize: "1rem", fontWeight: 600 }}>
              {" "}
              última versão
            </i>
          )}
        </div>
        <div className={`p-card-subtitle `}>{`${item.auditoriaDTO.usuario}  -  ${item.auditoriaDTO.dataFormatada}`}</div>
      </div >
      <hr className={style.separador} />

      <div className={`p-grid `} >
        <RotuloSeplag nome="CPF do Beneficiário" cols="12 6">
          <InputText disabled value={item.numCpfFormatado} id='numCpfFormatado' />
        </RotuloSeplag>

        <RotuloSeplag nome="Nome Beneficiário" cols="12 6">
          <InputText value={item.pessoa.nomePessoa} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Órgão de Origem" cols="12 6">
          <Dropdown
            optionLabel="descOrgao"
            id="orgao"
            value={item.orgao}
            options={optionsOrgaoDeOrigemDaObrigacao}
            disabled
          />
        </RotuloSeplag>

        <RotuloSeplag nome="Tipo  Certidão" cols="12 6">
          <InputText value={item.tipoCertidao.nomeTipoCertidao} id="nomeTipoCertidao" disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Bruto" cols="12 2">
          <InputNumber value={Number(item.valrBruto)} disabled />
        </RotuloSeplag>

        <RotuloSeplag nome="Emolumentos" cols="12 2">
          <InputNumber disabled value={Number(item.valrEmolumento)} />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor I.R" cols="12 2">
          <InputNumber disabled value={Number(item.valrIr)} />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Honorário" cols="12 2">
          <InputNumber disabled value={Number(item.valrHonorario)} />
        </RotuloSeplag>

        <RotuloSeplag nome="Outro Valor" cols="12 2">
          <InputNumber disabled value={Number(item.valrOutro)} />
        </RotuloSeplag>

        <RotuloSeplag nome="Valor Líquido" cols="12 2">
          <InputNumber disabled value={(item.valrBruto - item.valrEmolumento - item.valrIr - item.valrHonorario - item.valrOutro)} />
        </RotuloSeplag>

        <RotuloSeplag nome="Data da Quitação" cols="12 6">
          <InputText disabled value={item.dataQuitacao} />
        </RotuloSeplag>

        <RotuloSeplag nome="Data do Cancelamento" cols="12 6">
          <InputText disabled value={item.dataCancelamento ? item.dataCancelamento : ""} />
        </RotuloSeplag>

        <RotuloSeplag nome="Código Validador" cols="12 6">
          <InputText disabled value={item.codgValidadorObrigacao ? item.codgValidadorObrigacao : ""} />
        </RotuloSeplag>

        <RotuloSeplag nome="Situação" cols="12 6">
          <InputText disabled value={item.flagSituacao} />
        </RotuloSeplag>

        <RotuloSeplag nome="Complemento" cols="12 6">
          <InputText disabled id="descComplemento" value={item.descComplemento} />
        </RotuloSeplag>
      </div>
    </Card>
  )
}

export default CustomizedContent;